import { createReducer } from '@reduxjs/toolkit';

import patchCoOrder from '../../../thunks/coilovers/orders/patchCoOrder';
import { clearPatchCoOrders } from '../../../actions/coilovers/orders/patchCoOrders';

const initialState = {
  loading: false,
  error: null,
  data: {},
};

const patchCoOrderReducer = createReducer(initialState, {
  [patchCoOrder.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [patchCoOrder.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [patchCoOrder.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearPatchCoOrders]: () => initialState
});

export default patchCoOrderReducer;
